module.exports = __webpack_public_path__ + "fonts/SourceSansPro-SemiBold.83476a89.ttf";